<template>
    <div>
        <div>
            <table class="table table-bordered table-sm mb-1" style="font-size:smaller">
                <thead>
                    <td>Product</td>
                    <td class="text-center" style="width:15%">Quantity</td>
                    <td style="width:1%"></td>
                </thead>
                <tbody>
                    <tr v-if="subproducts.length === 0">
                        <td colspan="3" class="text-center text-muted">-No Products Added-</td>
                    </tr>

                    <tr v-for="(subproduct, index) in sortedSubProducts" :key="subproduct.subproduct_id">
                        <td class="align-middle">
                            {{ subproduct.subproduct.id }} - {{ subproduct.subproduct.title }}
                            <template v-if="subproduct.subproduct.description"> - {{ subproduct.subproduct.description }}</template>
                            <template v-if="subproduct.subproduct.size"> - {{ subproduct.subproduct.size }}</template>
                            <div>
                                <jet-input
                                    type="checkbox"
                                    class="h-3 w-3"
                                    :id="'subitem_' + index + '_hidden_from_customer'"
                                    :name="'subitem_' + index + '_hidden_from_customer'"
                                    :checked="subproduct.hidden_from_customer"
                                    @change="subproduct.hidden_from_customer = !subproduct.hidden_from_customer">
                                </jet-input>

                                <label class="custom-control-label ml-2 text-xs" :for="'subitem_' + index + '_hidden_from_customer'">Hidden From Customer</label>
                            </div>
                        </td>
                        <td>
                            <input-quantity
                                v-model.number="subproduct.qty"
                                placeholder="Quantity"
                                class="text-right"
                                required
                                :step="0.0001"
                                :min="0"
                            />
                        </td>
                        <td class="px-2 align-middle">
                            <a href="#" @click.prevent="removeProduct(index)">
                                <font-awesome-icon :icon="['fas', 'trash']" />
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="flex w-full mt-2">
            <div class="text-nowrap align-self-center" style="font-size:smaller">Add Product:</div>
            <input-quantity
                v-model.number="qty"
                placeholder="Quantity"
                class="text-right mr-2 w-1/3"
                ref="subproductQty"
                :step="0.0001"
                :min="0"
            />

            <multiselect class="multi-custom multi-custom-append"
                :options="productOptions"
                valueProp="id"
                :trackBy="['id', 'title']"
                label="title"
                :searchable="true"
                @select="addProduct"
                placeholder="Select an product or type to search"
                ref="multiselect"
            >
                <template v-slot:option="{ option }">
                    <span
                        :class="{ 
                            'text-red-500' : (option.special_order === true || option.category_id === this.dairyCategory),
                            'text-gray-400' : option.enabled === false
                        }"
                    >
                        <div v-if="option.enabled === false">
                            <span class="text-xs text-white bg-red-400 rounded py-1 px-2">Inactive</span>
                        </div>
                        
                        {{ option.id }} - {{ option.title }}
                        <template v-if="option.description"> - {{ option.description }}</template>
                        <template v-if="option.size"> - {{ option.size }}</template>
                        <span class="text-xs italic text-red" v-if="option.special_order">(Special Order Item)</span>
                    </span>
                </template>
            </multiselect>
        </div>
    </div>
</template>

<script>
import InputQuantity from '@/Jetstream/InputQuantity';
import Multiselect from '@vueform/multiselect';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label';
import '@vueform/multiselect/themes/default.css';

export default {
    components: {
        Multiselect,
        InputQuantity,
        JetInput,
        JetLabel,
    },

    props: ['products', 'subproducts', 'categories'],

    data() {
        return {
            qty: null,
        }
    },

    methods: {
        addProduct(selected) {
            let product = this.products.find(i => i.id === selected);

            this.subproducts.push({
                subproduct_id: selected,
                qty: this.qty,
                hidden_from_customer: false,
                subproduct: JSON.parse(JSON.stringify(product)),
            });

            this.qty = null;
            this.$refs.subproductQty.$el.focus();
            this.$refs.multiselect.clear();
        },

        removeProduct(index) {
            this.subproducts.splice(index, 1);
        },
    },

    computed: {
        productOptions() {
            return this.products.filter(i => {
                return this.subproducts.findIndex(s => s.subproduct_id === i.id) === -1;
            });
        },

        sortedSubProducts() {
            return this.subproducts.sort((a,b) => {
                if (a.title > b.title) return 1;
                if (a.title < b.title) return -1;

                return 0;
            });
        },

        dairyCategory() {
            let category = this.categories.find(c => c.id == 96);

            if(category === undefined) return null;

            return category.id;
        },
    }
}
</script>
